module.exports = __webpack_public_path__ + "static/img/72-1.7a0e0a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/72-1.jpg
// module id = 6bnG
// module chunks = 0